import React, { forwardRef, useEffect, useState } from 'react';
import EditForm from '../../../components/forms/EditForm.jsx';
import { useBookingFormQuery } from '../../../lib/Queries';
import Loading from '../../../components/Loading';
import { useCompleteStep } from '../../../lib/Onboarding.js';

const SchedulingPagesPage = ({ initialTab }) => {
    const { isLoading, data } = useBookingFormQuery();
    const bookingFormId = data?.bookingFormId;
    const { complete } = useCompleteStep();

    useEffect(() => {
        complete('scheduling-customize');
    }, []);

    return (
        <div>
            {!!bookingFormId && (
                <EditForm formId={bookingFormId} initialTab={initialTab} />
            )}
            {!bookingFormId && !isLoading && (
                <div className="text-red-700 flex items-center justify-center min-h-screen">
                    Error, unable to find booking form. Please contact support
                    or create a new business.
                </div>
            )}
            {isLoading && <Loading />}
        </div>
    );
};

export default SchedulingPagesPage;
